import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../Button/Button";
import GoogleIncIcon from "../../assests/img/GoogleInc.png";
import { ReactComponent as Tag } from "../../assests/svg/Tag/blue_tag.svg";
import { ReactComponent as MailIcon } from "../../assests/svg/mail.svg";
import { ReactComponent as GreenTag } from "../../assests/svg/Tag/dark_green.svg";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const GoogleIncClient = (props) => {
  const {prepaidClient, floatBalance } = props;
  const history = useNavigate();
  const { t } = useTranslation();

  const giftcardOrderData = useSelector((state) => state.createOrder);

  // order total calculations
  const orderamount =
    giftcardOrderData?.createorderData?.quantity *
    (giftcardOrderData?.createorderData?.product?.giftcard_value_type ===
    "denominations"
      ? giftcardOrderData?.createorderData?.denomination?.denomination_value
      : giftcardOrderData?.createorderData?.rangeDenomination);
  const discountedamount =
    (orderamount *
      giftcardOrderData?.createorderData?.selectedProduct?.client_discount) /
    100;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const addFloat = () => {
      history("/float/addfloat-details");
  };

  return (
    <div className="card-body d-flex flex-column justify-content-between bg-white shadow-sm rounded-3 mb-2 gap-3">
      <div className="d-flex flex-row gap-3 py-2  align-items-center">
        <div className="d-flex flex-grow-1">
          <div className="d-flex flex-column gap-3 mb-1  py-2  px-2 align-items-center">
            <div className="d-flex flex-row mx-2 gap-4 justify-content-between">
              <img
                src={GoogleIncIcon}
                alt="not found"
                className="img-fluid rounded-3 "
              />
              <div>
                <span className="font-22 font-boldest text-dark ">
                  {
                    giftcardOrderData?.createorderData?.selectedClient
                      ?.partner_name
                  }
                </span>
                <br />
                <span className="font-15 font-bold">{t("Client ID")} # </span>
                <span className="font-13 font-bold text-muted">
                  {/* Client ID #54123 */}
                  {giftcardOrderData?.createorderData?.selectedClient?.id}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column  gap-3 mb-1  mx-2 align-items-end">
         {giftcardOrderData?.createorderData?.selectedClient?.float_flag === true && <div className="d-flex">
            <Button
              type="rounded"
              text="+ Top up"
              className="rounded-5 my-4 mt-6 fw-bolder"
              onClick={addFloat}
            />
          </div>}
         {giftcardOrderData?.createorderData?.selectedClient && <span className="font-14 font-bold">
            <MailIcon />{" "}
            {giftcardOrderData?.createorderData?.selectedClient?.email}
          </span>}
          {prepaidClient === false && (
            <span className="font-14 font-bold text-pink">{t("Postpaid Client")}</span>
          )}
        </div>
      </div>

      {giftcardOrderData?.createorderData?.selectedClient?.float_flag ===
        true && (
          <div className="d-flex gap-3 my-4 px-4 align-items-center">
            <GreenTag />
            <span className="font-20 font-bold">
              {t("Available Float Balance")}:
              <span className="font-20 font-bold text-pink ">
                {" "}
                {floatBalance?.country?.currency_symbol}
                {floatBalance?.balance ? floatBalance?.balance : "00"}
              </span>
            </span>
          </div>
        )}
    </div>
  );
};

export default GoogleIncClient;
